export const hasProp = <T, K extends string>(
    object: T,
    key: K,
): object is T & Record<K, unknown> => {
    return Boolean(object && typeof object === 'object' && key in object)
}
